module.exports = __webpack_public_path__ + "img/magenta-bg.fcc111d8.jpg";